<template>
	<div
		style='width:100%'
	>

		<v-list-item-title class='primary--text font-weight-bold border-bottom-light'>
			<v-row align='center' style='height:46px'>
				<v-col cols='9' class='pt-0 pb-0 align-center'>
					<span class='pl-4' v-html='currentFilter.label' />
				</v-col>
				<v-col cols='3' class='align-center pt-0 pb-0 text-right pr-4'>
					<v-btn icon @click='abort()'>
						<v-icon size='20' color='primary'>
							fal fa-times
						</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-list-item-title>

		<v-list-item
			ref='filter-content'
			:style='{
				minHeight: min_height
			}'
		>
			<v-container class='align-baseline align-self-baseline'>

				<component
					:is='filterComponentName'
					v-if='currentFilter'
					:key='currentFilter.label'
					:filter.sync='currentFilter'
				>
					<template v-slot:search>
						<div v-if='showSearch' style='width: 100%; color: #000'>
							<v-text-field
								v-model='$store.dialogSearchText'
								placeholder='Suche'
								append-icon='far fa-search'
								hide-details
								clearable
								class='search-input'
								clear-icon='far fa-times'
								style='padding-top:0'
								@click:clear='$store.dialogSearchText = ""'
							/>
						</div>
					</template>

				</component>

			</v-container>
		</v-list-item>
		<v-list-item
			class='modal-footer'
		>
			<v-spacer />

			<v-btn
				color='primary'
				text
				style='height: 40px!important;margin-right: 30px; margin-top: 3px'
				@click='abort()'
			>
				Abbrechen
			</v-btn>

			<v-btn
				color='#C62929'
				style='color: white; height: 40px!important;'
				class='details-btn save-btn filter-cars'
				depressed
				@click='save(currentFilter)'
			>
				Autos anzeigen ({{ total_cars }})
			</v-btn>
		</v-list-item>
	</div>
</template>

<script>
import DependencyFilter from '@/components/filter/DependencyFilter'
import DropdownFilter from '@/components/filter/DropdownFilter'
import TilesFilter from '@/components/filter/TilesFilter'
import SliderFilter from '@/components/filter/SliderFilter'
import DurationFilter from '@/components/filter/DurationFilter'
import SelectFilter from '@/components/filter/SelectFilter'
import ConditionFilter from '@/components/filter/ConditionFilter'
import LocationFilter from '@/components/filter/LocationFilter'
import RangeFilter from '@/components/filter/RangeFilter'

import PowerFilter from '@/components/filter/PowerFilter'

import throttle from 'lodash.throttle'


export default {
	name: 'FilterContent',

	components: {DependencyFilter, DropdownFilter, TilesFilter, LocationFilter, SliderFilter, DurationFilter, SelectFilter, ConditionFilter, RangeFilter, PowerFilter},

	props: {
		currentFilter: {
			required: true,
      type: Object

		},
		close: {
		  required: true,
      type: Function
    }
	},

	data() {
		return {
			total_cars: this.$store.pagination.total,
			min_height: 0
		}
	},
  computed: {
		filterComponentName() {
			if (!this.currentFilter.type) return ''
			return this.currentFilter.type.charAt(0).toUpperCase() + this.currentFilter.type.slice(1) + 'Filter'
		},

		showSearch() {
			return this.currentFilter.type === 'select' && Array.isArray(this.currentFilter.values) && this.currentFilter.values.length > 7
		}
	},
	watch: {
		'$store.dialogSearchText'() {

			// dont shrink if options are filtered
			let currentDialogHeight = this.$refs['filter-content'].$el.clientHeight

			if (currentDialogHeight > parseInt(this.min_height)) this.min_height = currentDialogHeight + 'px'
		},

		currentFilter: {
			deep: true,

			handler: throttle(function () {
					this.$store.actions.getVehiclesCount(this.currentFilter).then(res => this.total_cars = res)
				}
			)
		}
	},

	methods: {
		closeModal() {
			this.min_height = 0
			this.$store.dialogSearchText = ''
      this.$emit('input', false)
      this.$emit('update:current-filter', {})
		},
    abort() {
      this.$bus.$emit('abort:'+this.currentFilter.name, {})
      this.close(this.currentFilter)
    },
		save(currentFilter) {
      this.$store.actions.updateFiltersInStore(this.currentFilter).then(() => {
        this.close(currentFilter);
        this.closeModal()
      })
		},
	}
}
</script>

<style>
#filter-dialog .v-toolbar__content {
	justify-content: space-between;
}
.border-bottom-light {
  border-bottom: solid 1px #d0d0d0;
}
.modal-footer {
  padding: 0 15px 15px 0;
  align-items: flex-end;
}
.save-btn {
  font-weight: bold;
  font-size: 14px !important;
}
.search-input input[type="text"]::placeholder {
  color: #000;
  font-weight: normal;
  font-size: 14px;
}
</style>
